module.exports = __webpack_public_path__ + "assets/6d49b3e4eff2a52c9fceebc050c416af.mp3";